const { handleError, handleResponse, api } = require("./baseApi");
const api_config = require("./api_config");
var qs = require('qs');

const BASE_URL = "impacts/v1";

function getImpactAllApi(locale) {
    return api
        .get(`${BASE_URL}/all?locale=${locale}`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function getFlightsImpactApi(locale) {
    return api
        .get(`${BASE_URL}/flights?locale=${locale}`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function getImpactByProjectCodeApi(projectCode, locale) {
    let params = {
        projectCode,
        locale
    }

    return api
        .get(`${BASE_URL}/projects/`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            },
            params: params
        })
        .then(handleResponse)
        .catch(handleError);
}

function getImpactMerchantApi(merchant, locale) {
    return api
        .get(
            `${BASE_URL}/merchants/${merchant ||
            api_config.x_merchant_code}?locale=${locale}`,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                }
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

function getImpactGroupApi(groupId, locale) {
    let params = {
        locale
    }

    return api
        .get(`${BASE_URL}/groups/${groupId}/`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            },
            params: params
        })
        .then(handleResponse)
        .catch(handleError);
}

function getImpactTransactionApi(transactionId, locale) {
    return api
        .get(`${BASE_URL}/purchases?purchaseId=${transactionId}&locale=${locale}`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function getImpactUserApi(userIds, locale) {
    let params = {
        userIds,
        includeProjects: false,
        locale
    }

    return api
        .get(`${BASE_URL}/users/`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            },
            params: params,
            paramsSerializer: params => qs.stringify(params,
                { arrayFormat: 'repeat' })
        })
        .then(handleResponse)
        .catch(handleError);
}

function getImpactUserByEmailApi(emails, locale) {
    const encodedEmails = emails.map(item => encodeURIComponent(item));

    return api
        .get(`${BASE_URL}/users/?emails=${encodedEmails}&locale=${locale}`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function getRoadTripUsers(email, locale) {
    return api
        .get(`${BASE_URL}/roadtrip/users`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            },
            params: {email, locale}
        })
        .then(handleResponse)
        .catch(handleError);
}

module.exports = {
    getImpactByProjectCodeApi,
    getImpactMerchantApi,
    getImpactGroupApi,
    getImpactTransactionApi,
    getImpactAllApi,
    getImpactUserApi,
    getImpactUserByEmailApi,
    getFlightsImpactApi,
    getRoadTripUsers
};
